// removed by extract-text-webpack-plugin
module.exports = {"user-info-left-wrap":"user-info-left-wrap","user-info-left":"user-info-left","user-form-group":"user-form-group","user-info-right-wrap":"user-info-right-wrap","user-content":"user-content","user-info-upload-img-wrap":"user-info-upload-img-wrap","upload-img-container":"upload-img-container","update-link":"update-link","user-info-right":"user-info-right","form-control":"form-control"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/user-info/_UserInfo.scss
// module id = ./components/users/sub-view/user-info/_UserInfo.scss
// module chunks = 0